import React, { Component } from 'react'
import GenericHeader from '../GenericHeader'
import { Button } from 'antd'
import { connect } from 'react-redux'
import { switchPages } from '../../actions'

@connect(
  null,
  { switchPages },
)
class SuccessScreen extends Component {
  onClick = () => {
    this.props.switchPages('dashboard')
  }
  render() {
    return (
      <div>
        <GenericHeader height="60px" />
        <div className="col text-center">
          <div style={{ marginTop: '100px' }}>
            <h2>Transaction Successful</h2>
            <Button onClick={this.onClick}>Done</Button>
          </div>
        </div>
      </div>
    )
  }
}
export default SuccessScreen



// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/InternetBankingSimulatorApp/screens/SuccessScreen/index.js